import { render, staticRenderFns } from "./PlaceOrder.vue?vue&type=template&id=0a24fa0a&scoped=true"
import script from "./PlaceOrder.vue?vue&type=script&lang=js"
export * from "./PlaceOrder.vue?vue&type=script&lang=js"
import style0 from "./PlaceOrder.vue?vue&type=style&index=0&id=0a24fa0a&prod&lang=css"
import style1 from "./PlaceOrder.vue?vue&type=style&index=1&id=0a24fa0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a24fa0a",
  null
  
)

export default component.exports